import clsx from "clsx";
import { Colour, colourToBgClassMap } from "../constants";

type ChipProps = {
    children: React.ReactNode;
    onClick?: () => void;
    colour: Colour;
    className?: string;
};

const Chip = ({ children, onClick, colour, className }: ChipProps) => {
    const commonClassName =
        "text-white text-center rounded-md text-xs py-1 px-3";

    if (onClick)
        return (
            <button
                onClick={onClick}
                className={clsx(
                    commonClassName,
                    className,
                    colourToBgClassMap[colour],
                    "transition-colors hover:bg-surface-light-2"
                )}
            >
                {children}
            </button>
        );

    return <span 
                className={clsx(
                    commonClassName,
                    className,
                    colourToBgClassMap[colour]
                )}>
                    {children}
                </span>;
};

export default Chip;
